import { render } from "./AltaViajero.vue?vue&type=template&id=258e6c2c"
import script from "./AltaViajero.vue?vue&type=script&lang=js"
export * from "./AltaViajero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__